import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useFaqContext } from "@/components/General/Faq/context/faq.context";
import { Mapped } from "@/context/mapped.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Accordion = ({ className, children }: Props) => {
    const { selection } = useFaqContext();

    return (
        <div className={cn("tw:grow", className)}>
            <h3
                className={cn("tw:my-2 tw:text-xl", "tw:hidden", "tw:md:block")}
            >
                {selection.category.title}
            </h3>
            <Mapped array={selection.category.faqQuestions}>{children}</Mapped>
        </div>
    );
};
